import { render } from "./StakesHistogram.vue?vue&type=template&id=00ac88dd&ts=true"
import script from "./StakesHistogram.vue?vue&type=script&lang=ts"
export * from "./StakesHistogram.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__